import { allScopes } from '../../shared';

export const available = true;
export const scope = allScopes;
